export const inputStyle = {
  maxWidth: 300
}
export const labelInputStyle = {
  maxWidth: 300
}

export const labelStyle = {
  fontFamily: 'Oswald, sans-serif',
  overflow: 'visible'
}

export const formWrapperStyle = {
  paddingTop: 30,
  paddingBottom: 30
}

// Section 1 constants
export const housingLabel = 'Housing'
export const utilitiesLabel = 'Utilities'
export const foodLabel = 'Food'
export const transportationLabel = 'Transportation'
export const insuranceLabel = 'Insurance'

export const income1FormKeys = [
  housingLabel,
  utilitiesLabel,
  foodLabel,
  transportationLabel,
  insuranceLabel
]

// Section 2 constants
export const clothesLabel = 'Clothing'
export const diningEntLabel = 'Dining & Entertainment'
export const diningEntKey = 'dining-ent'
export const digitalSvcsLabel = 'Digital Services'
export const digitalSvcsKey = 'digitalServices'
export const giftsLabel = 'Gifts'

export const income2FormKeys = [
  clothesLabel,
  diningEntKey,
  digitalSvcsKey,
  giftsLabel
]

// Section 3 dynamic entry base
export const debKey = 'dynamicEntry'

// Section 5 constants
export const yearsUntilRetirementLabel = 'Years Until Retirement'
export const yearsInRetirementLabel = 'Years In Retirement'
export const yearsUntilRetirementKey = 'yearsUntilRetirement'
export const yearsInRetirementKey = 'yearsInRetirement'
export const inflationEstimateLabel = 'Average Annual Inflation'
export const inflationEstimateKey = 'averageAnnualInflation'

// Section 6 constants
export const taxDeferredSavingsLabel = 'Tax Deferred Savings'
export const taxFreeSavingsLabel = 'Tax Free Savings'
export const taxDeferredSavingsKey = 'taxDeferredSavings'
export const taxFreeSavingsKey = 'taxFreeSavings'
export const taxRateLabel = 'Tax Rate'
export const taxRateKey = 'taxRate'
export const preAssetsReturnLabel = 'Average Annual Return Before Retirement'
export const postAssetsReturnLabel = 'Average Annual Return After Retirement'
export const preAssetsReturnKey = 'preAssetsReturn'
export const postAssetsReturnKey = 'postAssetsReturn'

// Section 7 constants
export const ssIncomeLabel = 'Social Security'
export const ssIncomeKey = 'socialSecurity'
export const pensionIncomeLabel = 'Pension'
export const pensionIncomeKey = 'pension'

/**
 * Get an array of formKeys for a given number of formLines
 * @param sectionNumber
 * @param numLines
 * @returns {Array}
 */
export function getFormKeysArray (sectionNumber, numLines) {
  const formKeysArr = []
  for (let i = 0; i < numLines; i++) {
    const key = `${debKey}${sectionNumber}${i.toString()}`
    formKeysArr.push(key)
  }
  return formKeysArr
}



// WEBPACK FOOTER //
// ./src/components/forms/form.js